import * as React from "react"
import Layout from '../components/layout';
import { graphql, StaticQuery } from "gatsby";
import { Scrollbar } from "react-scrollbars-custom";
import { Helmet } from "react-helmet";
import LinkCustom from '../components/TransitionLinks/LinkCustom';
import useSiteMetadata from '../components/use-site-metadata';

export default (props) => (
  <StaticQuery
    query={graphql`
      query allstories {
        allMarkdownRemark(
          sort: { order: ASC, fields: [frontmatter___name] }
          limit: 1000
        ) {
          nodes {
            frontmatter {
              path
              name
              thumbnailImage{
                publicURL
              }
              bullets
              quote
            }
          }
        }
      }
    `}
    render={data => {

      const { title } = useSiteMetadata();
      const { siteUrl } = useSiteMetadata();
      
      const stories = data.allMarkdownRemark.nodes;

      var storylist = stories.map(function(story,index){

        // var bulletlist = story.frontmatter.bullets.map((bullet) =>
        //   <li>{bullet}</li>
        // );

        return (
          <li className="story" key={index}>
            <LinkCustom effect="fade" length={2} url={story.frontmatter.path}>
              <img src={story.frontmatter.thumbnailImage.publicURL} alt="" className="story-thumbnail" />
              <span className="story-name">{story.frontmatter.name}</span>
              <p className="story-desc quote">“{story.frontmatter.quote}”</p>
              {/* <ul className="story-desc">
                {bulletlist}
              </ul> */}
            </LinkCustom>
          </li>
        )
      })

      return (
        <Layout location={props.location}>
          <Helmet>
            <title>Our Stories</title>
            <meta itemprop="name" content={`${"Our Stories | "}${title}`}  />
            <meta name="twitter:title" content={`${"Our Stories | "}${title}`}  />
            <meta property="og:title" content={`${"Our Stories | "}${title}`}  />
            <link rel="canonical" href={`${siteUrl}${"/all-stories"}`} />
            <meta property="og:url" content={`${siteUrl}${"/all-stories"}`} />
          </Helmet>
          <section className="page-content-wrapper all-stories">
            <Scrollbar style={{ height: '100%' }} >
              <h1>Our Stories</h1>
              <ul className="story-list">{storylist}</ul>
            </Scrollbar>
          </section>
        </Layout>
      )
        

    }}
  />
)